const locale = {
    placeholder: 'Velja tíma',
};
export default locale;
